<template>
  <div>
    <el-form-item :label="$t('i18n.b985c54ec0b64c37852c22562475f1ce') + '1'" prop="startName">
      <el-input
        v-model="form.startName"
        maxlength="50"
        show-word-limit
        :placeholder="$t('i18n.a6d61a9d34474ef5bcbb83938e05c756')"
      ></el-input>
    </el-form-item>
    <el-form-item :label="$t('i18n.b985c54ec0b64c37852c22562475f1ce') + '2'" prop="endName">
      <el-input
        v-model="form.endName"
        maxlength="100"
        show-word-limit
        :placeholder="$t('i18n.a6d61a9d34474ef5bcbb83938e05c756')"
      ></el-input>
    </el-form-item>
    <el-form-item :label="$t('i18n.b985c54ec0b64c37852c22562475f1ce') + '3'" prop="longName">
      <el-input
        v-model="form.longName"
        maxlength="50"
        show-word-limit
        :placeholder="$t('i18n.a6d61a9d34474ef5bcbb83938e05c756')"
      ></el-input>
    </el-form-item>
    <el-form-item :label="$t('i18n.78209f56e1884816bad4aac43c7a1a7b')" prop="tips">
      <el-input
        v-model="form.tips"
        maxlength="50"
        disabled
        show-word-limit
        :placeholder="$t('i18n.2afee910006744ee82e19faabf3add31')"
      ></el-input>
    </el-form-item>
    <el-form-item :label="$t('i18n.UXGpCUoypv3R')" prop="region">
      <el-checkbox v-model="form.isEditDuration"
        >{{ $t('07baeba6') }}
        <el-tooltip
          class="item"
          effect="dark"
          :content="$t('i18n.eb3b4e3329594fd8bbbbca7990e54ec7')"
          placement="top-start"
        >
          <i class="el-icon-question"></i>
        </el-tooltip>
      </el-checkbox>
    </el-form-item>
    <el-form-item :label="$t('i18n.3c7b311abb3c44e282c8e8ea062a5722')" prop="dateType">
      <el-select v-model="form.dateType" :placeholder="$t('221')">
        <el-option v-for="item in dateTypeOptions" :key="item.type" :label="item.label" :value="item.type"> </el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="$t('f07baeba')" prop="timeType">
      <el-radio-group v-model="form.timeType">
        <el-radio :label="item.type" v-for="item in timeOptions" :key="item.type">{{ item.label }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item :label="$t('i18n.0a5d225866204083972f74127963080b')" prop="require">
      <el-checkbox v-model="form.require">{{ $t('i18n.ca2f54a11aaf46d49f46588e55bbab1a') }}</el-checkbox>
    </el-form-item>
  </div>
</template>

<script>
import { dateTypeOptions, timeOptions } from '../../enum'
export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // 时间类型枚举
      dateTypeOptions,
      timeOptions
    }
  }
}
</script>
